import React from 'react'
import classes from './LoadingButton.module.scss'
import Button, { ButtonProps } from '@/components/ui/Buttons/Button/Button'
import clsx from 'clsx'
import { Puff } from '@/components/ui/Loaders'

export type LoadingButtonProps = {
  isLoading?: boolean
} & ButtonProps

export const LoadingButton = ({ isLoading = false, children, ...props }: LoadingButtonProps) => {
  return (
    <Button {...props} disabled={isLoading || props.disabled}>
      <span className={classes.root}>
        {isLoading && (
          <span className={classes.loader}>
            <Puff size={16} />
          </span>
        )}
        <span className={clsx(isLoading && classes.loadingChildren)}>{children}</span>
      </span>
    </Button>
  )
}
